/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for AuditResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, AuditEvent } from "../models";

@Injectable({ providedIn: "root" })
export class AuditResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    findByDates(fromDate: string, toDate: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<AuditEvent>>;
    findByDates(fromDate: string, toDate: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<AuditEvent>>>;
    findByDates(fromDate: string, toDate: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<AuditEvent>>>;
    findByDates(fromDate: string, toDate: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/audits/byDates`;

        let params = new HttpParams();
        if (fromDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, fromDate, 'fromDate');
        }
        if (toDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, toDate, 'toDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAll(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<AuditEvent>>;
    findAll(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<AuditEvent>>>;
    findAll(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<AuditEvent>>>;
    findAll(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/api/audits/all`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
